import TableCellContent, { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import TableCellGroup from "ds/components/Table/Row/CellGroup";

type EnvironmentTableCellProps = TableCellContentProps & {
  isFirst: boolean;
  onToggle?: () => void;
  isExpanded?: boolean;
};

const EnvironmentTableCell = ({
  children,
  isFirst,
  onToggle,
  isExpanded,
  ...props
}: EnvironmentTableCellProps) => {
  return (
    <TableCellContent {...props}>
      <TableCellGroup
        isActive={isFirst && !!onToggle}
        onPress={onToggle}
        title="View file"
        isGroupOpen={isExpanded}
      >
        {children}
      </TableCellGroup>
    </TableCellContent>
  );
};

export default EnvironmentTableCell;
